import { ApiUrl } from "../utils/modules";

class GroupeCategorieServices {
  constructor(api) {
    this.api = api;
  }

  create(data) {
    return this.api.post(ApiUrl + "groupeCategorie", data);
  }

  getAll() {
    return this.api.get(ApiUrl + "groupeCategorie");
  }

  getOne(id) {
    return this.api.get(ApiUrl + `groupeCategorie/${id}`);
  }

  update(id, data) {
    return this.api.put(ApiUrl + `groupeCategorie/${id}`, data);
  }

  delete(id) {
    return this.api.delete(ApiUrl + `groupeCategorie/${id}`);
  }
}

export default GroupeCategorieServices;
